@if (finishedAuthCheck() === false) {
  <mat-progress-bar mode="indeterminate">
    Loading
  </mat-progress-bar>
} @else {
  <router-outlet/>
}

<!-- @if (finishedAuthCheck()) {
  <router-outlet/>
} -->
